/* طبقة تخزين سحابية - window.storage فوق app_state + مزامنة صامتة (بلا إعادة تحميل). */
import { supabase } from "./supabaseClient.js";
import { getOrgId } from "./api.js";

const WRITER = Math.random().toString(36).slice(2);
if (typeof window !== "undefined") window.__tpmsWriter = WRITER;

async function kvGet(key) {
  const org = await getOrgId(); if (!org) return null;
  const { data, error } = await supabase.from("app_state").select("value").eq("org_id", org).eq("key", key).maybeSingle();
  if (error) return null;
  return data ? { key, value: data.value } : null;
}
async function kvSet(key, value) {

  const org = await getOrgId(); if (!org) return null;
  const { error } = await supabase.from("app_state")
    .upsert({ org_id: org, key, value, writer: WRITER, updated_at: new Date().toISOString() }, { onConflict: "org_id,key" });
  if (error) { try { console.error("[tpms] kvSet", error); window.__tpmsLastErr = (error.message || JSON.stringify(error)); } catch {} return null; }
  return { key, value };
}
async function kvDelete(key) {
  const org = await getOrgId(); if (!org) return { key, deleted: true };
  await supabase.from("app_state").delete().eq("org_id", org).eq("key", key);
  return { key, deleted: true };
}
async function kvList() {
  const org = await getOrgId(); if (!org) return { keys: [] };
  const { data } = await supabase.from("app_state").select("key").eq("org_id", org);
  return { keys: (data || []).map((r) => r.key) };
}

const webStorage = { get: kvGet, set: kvSet, delete: kvDelete, list: kvList };

/* مزامنة صامتة: تغيير الزملاء يستدعي window.__tpmsRefresh (يوفّرها التطبيق)
   فتُقرأ الشجرة وتُحدَّث الشاشة في مكانها - لا إعادة تحميل أبدًا. */
let _rtStarted = false, _rtimer = null;
function scheduleRefresh() {
  if (_rtimer) clearTimeout(_rtimer);
  _rtimer = setTimeout(() => {
    if (Date.now() - (window.__tpmsSaving || 0) < 8000) return; // حفظنا نحن - تجاهل
    try { if (typeof window.__tpmsRefresh === "function") window.__tpmsRefresh(); } catch {}
  }, 1200);
}
async function startRealtime() {
  if (_rtStarted) return;
  _rtStarted = true;
  const org = await getOrgId();
  if (!org) { _rtStarted = false; return; }
  const onChange = () => {
    if (Date.now() - (window.__tpmsSaving || 0) < 8000) return;
    scheduleRefresh();
  };
  if (typeof window !== "undefined" && window.__tpmsRelCh) { try { supabase.removeChannel(window.__tpmsRelCh); } catch {} }
  window.__tpmsRelCh = supabase.channel("rel-" + org)
    .on("postgres_changes", { event: "*", schema: "public", table: "app_state", filter: "org_id=eq." + org }, (p) => {
      try { const k = (p && p.new && p.new.key) || (p && p.old && p.old.key); if (k === "pm:topmsg") window.dispatchEvent(new CustomEvent("pm:topmsg")); } catch {}
    })
    .on("postgres_changes", { event: "*", schema: "public", table: "rel_books", filter: "org_id=eq." + org }, onChange)
    .on("postgres_changes", { event: "*", schema: "public", table: "rel_projects", filter: "org_id=eq." + org }, onChange)
    .on("postgres_changes", { event: "*", schema: "public", table: "rel_publishers", filter: "org_id=eq." + org }, onChange)
    .subscribe();
}

function saveBytes(filename, bytes) {
  try {
    const blob = new Blob([bytes], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url); return true;
  } catch (e) { try { console.error("saveBytes", e); } catch {} return false; }
}


/* ============ حفظ شجري على جهاز المدير - منقول من tpmsv78 (Chrome: مجلد حقيقي / Safari: ZIP) ============ */
const FOLDER_NAME = "نظام إدارة مشاريع الترجمة";
const FILE_LABELS = {
  coverAr: "الغلاف_العربي", coverFr: "الغلاف_الأصلي",
  contractAuthor: "عقد_المؤلف", contractTrans1: "عقد_الترجمة",
  contractPublisher: "عقد_الناشر", printOfferFile: "عرض_الطباعة",
};
function safeName(x) {
  return String(x || "بدون اسم").replace(/[\/\\:*?"<>|\n\r\t]+/g, "_").replace(/\.+$/, "").trim().slice(0, 90) || "بدون اسم";
}
function extFromDataUrl(u) {
  const m = /^data:([^;]+)/.exec(u || ""); const mime = m ? m[1] : "";
  const map = { "image/jpeg": "jpg", "image/jpg": "jpg", "image/png": "png", "image/webp": "webp", "image/gif": "gif", "application/pdf": "pdf" };
  return map[mime] || "bin";
}
function dataUrlToBytes(u) {
  try { const i = u.indexOf(","); const bin = atob(u.slice(i + 1)); const arr = new Uint8Array(bin.length); for (let k = 0; k < bin.length; k++) arr[k] = bin.charCodeAt(k); return arr; }
  catch { return null; }
}
function fileDataUrl(v) {
  if (!v) return null;
  if (typeof v === "string") return v.startsWith("data:") ? v : null;
  if (typeof v === "object" && typeof v.data === "string" && v.data.startsWith("data:")) return v.data;
  return null;
}
function extOf(v, dataUrl) {
  if (v && typeof v === "object" && typeof v.name === "string") {
    const m = /\.([A-Za-z0-9]{1,8})$/.exec(v.name); if (m) return m[1].toLowerCase();
  }
  return extFromDataUrl(dataUrl);
}

let _dirHandle = null, _pendingDataJson = null;
function idb() { return new Promise((res, rej) => { const q = indexedDB.open("tpms-fs", 1); q.onupgradeneeded = () => q.result.createObjectStore("kv"); q.onsuccess = () => res(q.result); q.onerror = () => rej(q.error); }); }
async function idbSet(k, v) { try { const d = await idb(); await new Promise((res, rej) => { const t = d.transaction("kv", "readwrite"); t.objectStore("kv").put(v, k); t.oncomplete = res; t.onerror = rej; }); } catch {} }
async function idbGet(k) { try { const d = await idb(); return await new Promise((res) => { const t = d.transaction("kv", "readonly"); const q = t.objectStore("kv").get(k); q.onsuccess = () => res(q.result || null); q.onerror = () => res(null); }); } catch { return null; } }

async function ensureHandle() {
  if (!_dirHandle) _dirHandle = await idbGet("dirHandle");
  if (!_dirHandle) return null;
  try {
    let pm = await _dirHandle.queryPermission({ mode: "readwrite" });
    if (pm !== "granted") { try { pm = await _dirHandle.requestPermission({ mode: "readwrite" }); } catch {} }
    return pm === "granted" ? _dirHandle : null;
  } catch { return null; }
}

async function chooseFolder() {
  if (typeof window.showDirectoryPicker !== "function") return "ZIP"; // سفاري: تنزيل ZIP بنفس البنية
  try {
    const parent = await window.showDirectoryPicker({ mode: "readwrite" });
    const base = await parent.getDirectoryHandle(FOLDER_NAME, { create: true });
    _dirHandle = base; await idbSet("dirHandle", base);
    return FOLDER_NAME + " ← " + (parent.name || "المجلد المختار");
  } catch { return null; }
}

async function getDir(root, parts, create) { let h = root; for (const q of parts) h = await h.getDirectoryHandle(q, { create: !!create }); return h; }
async function writeFileH(dir, name, bytes) { const fh = await dir.getFileHandle(name, { create: true }); const w = await fh.createWritable(); await w.write(bytes); await w.close(); }
async function listDirs(h) { const out = []; try { for await (const [name, ch] of h.entries()) out.push({ name, kind: ch.kind, handle: ch }); } catch {} return out; }

async function writeData(base, jsonText) {
  if (base === "ZIP" || typeof window.showDirectoryPicker !== "function") { _pendingDataJson = jsonText; return { ok: true }; }
  const h = await ensureHandle();
  if (!h) return { ok: false, error: "انتهى إذن المجلّد - أعد اختياره من زر الربط" };
  try { await writeFileH(h, "data.json", new TextEncoder().encode(jsonText)); return { ok: true }; }
  catch (e) { return { ok: false, error: String(e && e.message || e) }; }
}

/* ZIP بلا ضغط (store) - أسماء UTF-8 عربية */
function crc32(buf) {
  let t = crc32._t;
  if (!t) { t = crc32._t = []; for (let n = 0; n < 256; n++) { let c = n; for (let k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; t[n] = c >>> 0; } }
  let crc = 0xFFFFFFFF;
  for (let i = 0; i < buf.length; i++) crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  return (crc ^ 0xFFFFFFFF) >>> 0;
}
function makeZip(entries) {
  const enc = new TextEncoder(); const chunks = []; const central = []; let offset = 0;
  const num = (n, b) => { const a = new Uint8Array(b); for (let i = 0; i < b; i++) a[i] = (n >>> (8 * i)) & 0xFF; return a; };
  for (const e of entries) {
    const nameB = enc.encode(e.path); const data = e.bytes; const crc = crc32(data);
    const parts = [num(0x04034b50, 4), num(20, 2), num(0x0800, 2), num(0, 2), num(0, 2), num(0, 2), num(crc, 4), num(data.length, 4), num(data.length, 4), num(nameB.length, 2), num(0, 2), nameB, data];
    central.push({ nameB, crc, size: data.length, offset });
    for (const a of parts) { chunks.push(a); offset += a.length; }
  }
  const cdStart = offset; let cdLen = 0;
  for (const c of central) {
    const cd = [num(0x02014b50, 4), num(20, 2), num(20, 2), num(0x0800, 2), num(0, 2), num(0, 2), num(0, 2), num(c.crc, 4), num(c.size, 4), num(c.size, 4), num(c.nameB.length, 2), num(0, 2), num(0, 2), num(0, 2), num(0, 2), num(0, 4), num(c.offset, 4), c.nameB];
    for (const a of cd) { chunks.push(a); cdLen += a.length; }
  }
  const end = [num(0x06054b50, 4), num(0, 2), num(0, 2), num(central.length, 2), num(central.length, 2), num(cdLen, 4), num(cdStart, 4), num(0, 2)];
  for (const a of end) chunks.push(a);
  const total = chunks.reduce((s2, a) => s2 + a.length, 0); const out = new Uint8Array(total); let pos = 0;
  for (const a of chunks) { out.set(a, pos); pos += a.length; }
  return out;
}

async function writeTree(base, publishers, opts) {
  const explicit = !!(opts && opts.explicit);
  const r = { ok: true, base, agencies: 0, projects: 0, books: 0, files: 0, errors: [], pruned: [], skipped: false };
  const zipMode = base === "ZIP" || typeof window.showDirectoryPicker !== "function";
  if (zipMode && !explicit) { r.skipped = true; return r; } // الحفظ التلقائي لا ينزّل ZIP - الضغطة الصريحة فقط
  const zipEntries = []; let root = null;
  const enc = new TextEncoder();
  if (!zipMode) {
    root = await ensureHandle();
    if (!root) { r.ok = false; r.errors.push("انتهى إذن المجلّد - أعد اختياره من زر الربط"); return r; }
  } else if (_pendingDataJson) { zipEntries.push({ path: "data.json", bytes: enc.encode(_pendingDataJson) }); _pendingDataJson = null; }
  const put = async (parts, name, bytes) => {
    if (zipMode) zipEntries.push({ path: parts.concat(name).join("/"), bytes });
    else { const d = await getDir(root, parts, true); await writeFileH(d, name, bytes); }
  };
  for (const pub of (publishers || [])) {
    if (!pub || pub.deleted) continue;
    try {
      const pubParts = [safeName(pub.name)];
      if (!zipMode) await getDir(root, pubParts, true);
      r.agencies++;
      for (const proj of (pub.projects || [])) {
        if (!proj || proj.deleted) continue;
        const projParts = pubParts.concat(safeName(proj.name));
        if (!zipMode) await getDir(root, projParts, true);
        r.projects++;
        for (const bk of (proj.works || [])) {
          if (!bk || bk.deleted) continue;
          try {
            const bkParts = projParts.concat(safeName(bk.name));
            if (!zipMode) await getDir(root, bkParts, true);
            r.books++;
            const info = {};
            for (const k in bk) {
              if (k === "finance" || k in FILE_LABELS) continue;
              const v = bk[k];
              if (typeof v === "string" && v.startsWith("data:")) continue;
              if (v && typeof v === "object" && typeof v.data === "string" && v.data.startsWith("data:")) continue;
              info[k] = v;
            }
            await put(bkParts, "معلومات.json", enc.encode(JSON.stringify(info, null, 2)));
            for (const key in FILE_LABELS) {
              const val = bk[key];
              const dataUrl = fileDataUrl(val);
              if (!dataUrl) continue;
              const bytes = dataUrlToBytes(dataUrl);
              if (bytes) { await put(bkParts, FILE_LABELS[key] + "." + extOf(val, dataUrl), bytes); r.files++; }
            }
            const fin = bk.finance;
            const secs = fin && Array.isArray(fin.sections) ? fin.sections : [];
            for (const sec of secs) {
              const invs = sec && Array.isArray(sec.invoices) ? sec.invoices : [];
              if (!invs.length) continue;
              const invParts = bkParts.concat("فواتير_" + safeName((sec && sec.name) || "قسم"));
              let n = 1;
              for (const inv of invs) {
                const u = inv && (inv.data || inv.url || (typeof inv === "string" ? inv : ""));
                if (typeof u === "string" && u.startsWith("data:")) {
                  const bytes = dataUrlToBytes(u);
                  if (bytes) { await put(invParts, "فاتورة_" + (n++) + "." + extFromDataUrl(u), bytes); r.files++; }
                }
              }
            }
          } catch (e) { r.errors.push("كتاب «" + (bk && bk.name) + "»: " + String(e && e.message || e)); }
        }
      }
    } catch (e) { r.errors.push("جهة «" + (pub && pub.name) + "»: " + String(e && e.message || e)); }
  }
  if (zipMode) {
    try { saveBytes(FOLDER_NAME + ".zip", makeZip(zipEntries)); } catch (e) { r.ok = false; r.errors.push("ZIP: " + String(e && e.message || e)); }
  } else {
    await pruneTreeH(root, publishers, r);
  }
  if (r.errors.length) r.ok = false;
  return r;
}

async function pruneTreeH(root, publishers, report) {
  try {
    const validAg = new Map();
    for (const pub of (publishers || [])) {
      if (!pub || pub.deleted) continue;
      const projMap = new Map();
      for (const proj of (pub.projects || [])) {
        if (!proj || proj.deleted) continue;
        const books = new Set(); const meta = new Map();
        for (const bk of (proj.works || [])) { if (!bk || bk.deleted) continue; const bn = safeName(bk.name); books.add(bn); meta.set(bn, bk); }
        projMap.set(safeName(proj.name), { books, meta });
      }
      validAg.set(safeName(pub.name), projMap);
    }
    for (const e of await listDirs(root)) {
      if (e.kind !== "directory") continue;
      if (!validAg.has(e.name)) { try { await root.removeEntry(e.name, { recursive: true }); report.pruned.push("جهة: " + e.name); } catch (x) { report.errors.push("حذف جهة " + e.name); } continue; }
      const projMap = validAg.get(e.name); const agH = e.handle;
      for (const pe of await listDirs(agH)) {
        if (pe.kind !== "directory") continue;
        if (!projMap.has(pe.name)) { try { await agH.removeEntry(pe.name, { recursive: true }); report.pruned.push("مشروع: " + pe.name); } catch (x) {} continue; }
        const { books, meta } = projMap.get(pe.name); const pjH = pe.handle;
        for (const be of await listDirs(pjH)) {
          if (be.kind !== "directory") continue;
          if (!books.has(be.name)) { try { await pjH.removeEntry(be.name, { recursive: true }); report.pruned.push("كتاب: " + be.name); } catch (x) {} continue; }
          const bk = meta.get(be.name); const bkH = be.handle;
          const keep = {};
          for (const key in FILE_LABELS) keep[FILE_LABELS[key]] = !!fileDataUrl(bk[key]);
          for (const fe of await listDirs(bkH)) {
            if (fe.kind !== "file") continue;
            if (fe.name === "معلومات.json") continue;
            for (const key in FILE_LABELS) {
              const label = FILE_LABELS[key];
              if (fe.name.startsWith(label + ".") && !keep[label]) { try { await bkH.removeEntry(fe.name); report.pruned.push("ملفّ: " + fe.name); } catch (x) {} }
            }
          }
        }
      }
    }
  } catch (e) { report.errors.push("مزامنة: " + String(e && e.message || e)); }
}


/* ============ prefsStore: تفضيلات المستخدم - localStorage فوري + user_prefs سحابي + حفظ مجمّع ============ */
const _prefsTimers = {};
function _uid() {
  try {
    if (typeof window !== "undefined" && window.__tpmsUid) return window.__tpmsUid;
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith("sb-") && k.endsWith("-auth-token")) {
        const o = JSON.parse(localStorage.getItem(k));
        const id = (o && o.user && o.user.id) || (o && o.currentSession && o.currentSession.user && o.currentSession.user.id) || "";
        if (id) { try { window.__tpmsUid = id; } catch {} return id; }
      }
    }
    return "";
  } catch { return ""; }
}
/* الخاص في Safari يحجب localStorage عن الجلسة - نسأل العميل نفسه ونخزن الناتج */
(async function _warmUid() {
  try {
    if (typeof window === "undefined" || window.__tpmsUid) return;
    const { data } = await supabase.auth.getSession();
    const id = data && data.session && data.session.user && data.session.user.id;
    if (id) window.__tpmsUid = id;
  } catch {}
})();
function _lsKey(field) { return "tpms:prefs:" + _uid() + ":" + field; }

const prefsStore = {
  /* قراءة فورية من النسخة المحلية - للرسم اللحظي بلا انتظار الشبكة */
  local(field) {
    try { const v = localStorage.getItem(_lsKey(field)); return v ? JSON.parse(v) : null; } catch { return null; }
  },
  /* جلب نسخة القاعدة (الحقيقة) وتحديث المحلية */
  async fetch(field) {
    const uid = _uid(); if (!uid) return null;
    try {
      const { data } = await supabase.from("user_prefs").select(field).eq("profile_id", uid).maybeSingle();
      const v = data ? data[field] : null;
      if (v != null) { try { localStorage.setItem(_lsKey(field), JSON.stringify(v)); } catch {} }
      return v;
    } catch { return null; }
  },
  /* حفظ: محلي فورًا + سحابي مجمّعًا (1.2 ثانية) */
  save(field, value) {
    const uid = _uid(); if (!uid) return;
    try { localStorage.setItem(_lsKey(field), JSON.stringify(value)); } catch {}
    if (_prefsTimers[field]) clearTimeout(_prefsTimers[field]);
    _prefsTimers[field] = setTimeout(async () => {
      try {
        let org = null;
        try { const o = (typeof window !== "undefined" && window.__tpmsOrg) || null; if (typeof o === "string" && o.length === 36) org = o; } catch {}
        if (!org) { try { const { data } = await supabase.from("profiles").select("org_id").eq("id", uid).maybeSingle(); org = data && data.org_id; if (org) window.__tpmsOrg = org; } catch {} }
        if (!org) return;
        /* بلا upsert وبلا إرجاع - درس pmAddBook: update ثم insert صريحان */
        const { error: ue, count } = await supabase.from("user_prefs")
          .update({ [field]: value, updated_at: new Date().toISOString() }, { count: "exact" })
          .eq("profile_id", uid);
        if (ue || !count) {
          const { error: ie } = await supabase.from("user_prefs")
            .insert({ profile_id: uid, org_id: org, [field]: value });
          if (ie && String(ie.code) !== "23505") throw ie;
          if (ie && String(ie.code) === "23505") {
            await supabase.from("user_prefs").update({ [field]: value, updated_at: new Date().toISOString() }).eq("profile_id", uid);
          }
        }
      } catch (e) { try { console.warn("[tpms] prefs save", field, e && e.message); } catch {} }
    }, 1200);
  },
};

if (typeof window !== "undefined") {
  window.storage = webStorage;
  window.pmSaveBytes = saveBytes;
  window.pmChooseFolder = chooseFolder;
  window.pmWriteData = writeData;
  window.pmWriteTree = writeTree;
  window.prefsStore = prefsStore;
  setTimeout(() => { startRealtime(); }, 1500);
  try { supabase.auth.onAuthStateChange(() => { startRealtime(); }); } catch {}
}

export { webStorage as storage };
